import React from "react";
import { ECLDateTimePicker, ECLTextInput } from "../../../index";
import ECLInteger from "../ECLObjectBlock/Inputs/ECLInteger";

export default function ECLFormFieldInput(props) {
   const { rows, inputType, block, handleInput, columns } = props;

   switch (inputType) {
      case "text":
         return (
            <ECLTextInput
               name={block.data.name}
               value={rows[0]}
               onChange={handleInput}
            />
         );

      case "number":
         return (
            <ECLInteger
               precision={columns[0].type.precision}
               name={block.data.name}
               value={rows[0]}
               onChange={handleInput}
            />
         );

      case "datetime":
         return <ECLDateTimePicker name={block.data.name} date={rows[0]} />;
      default:
         return <div>Unsupported Type</div>;
   }
}
